import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { EarlyBirdSection } from '../components/EarlyBirdSection';
import { PricingSection } from '../components/PricingSection';
import { LicensingSection } from '../components/LicensingSection';
import { PriceComparator } from '../components/PriceComparator';
import { WaitlistForm } from '../components/WaitlistForm';
import { useI18n } from '../context/I18nContext';

const ctaLabels = {
  en: { title: 'Ready to get started?', subtitle: 'Choose your plan and start editing PDFs offline today.', priceNote: 'Prices shown are indicative and may vary at checkout based on the current exchange rate.' },
  fr: { title: 'Pret a commencer ?', subtitle: 'Choisissez votre offre et commencez a editer vos PDFs hors ligne.', priceNote: 'Les prix affiches sont indicatifs et peuvent varier au moment de l achat selon le taux de change en vigueur.' },
  es: { title: 'Listo para empezar?', subtitle: 'Elige tu plan y empieza a editar PDFs sin conexion.', priceNote: 'Los precios mostrados son indicativos y pueden variar en el momento de la compra.' },
  de: { title: 'Bereit loszulegen?', subtitle: 'Wahlen Sie Ihren Plan und bearbeiten Sie PDFs offline.', priceNote: 'Die angezeigten Preise sind unverbindlich und konnen beim Kauf variieren.' },
  it: { title: 'Pronto per iniziare?', subtitle: 'Scegli il tuo piano e inizia a modificare i PDF offline.', priceNote: 'I prezzi indicati sono indicativi e possono variare al momento dell acquisto.' },
  pt: { title: 'Pronto para comecar?', subtitle: 'Escolha seu plano e comece a editar PDFs offline.', priceNote: 'Os precos apresentados sao indicativos e podem variar no momento da compra.' },
  nl: { title: 'Klaar om te beginnen?', subtitle: 'Kies uw plan en begin met het bewerken van PDFs offline.', priceNote: 'De getoonde prijzen zijn indicatief en kunnen varieren bij aankoop.' },
  pl: { title: 'Gotowy zaczac?', subtitle: 'Wybierz swoj plan i zacznij edytowac PDFy offline.', priceNote: 'Podane ceny maja charakter orientacyjny i moga sie roznic w momencie zakupu.' },
  tr: { title: 'Baslamaya hazir misiniz?', subtitle: 'Planinizi secin ve PDF duzenlemeye baslarin.', priceNote: 'Gosterilen fiyatlar gosterge niteligindedir ve satin alma sirasinda degisebilir.' },
  hi: { title: 'शुरू करने के लिए तैयार हैं?', subtitle: 'अपनी योजना चुनें और आज ही ऑफ़लाइन PDF संपादित करना शुरू करें।', priceNote: 'प्रदर्शित मूल्य सांकेतिक हैं और चेकआउट के समय विनिमय दर के अनुसार भिन्न हो सकते हैं।' },
};

export default function PricingPage() {
  const { lang } = useI18n();
  const cta = ctaLabels[lang] || ctaLabels.en;

  return (
    <div className="min-h-screen bg-background" data-testid="pricing-page">
      <Navbar />
      <div className="pt-16">
        <EarlyBirdSection />
        <PricingSection />
        <LicensingSection />
        <PriceComparator />
        {/* Indicative price note */}
        <div className="max-w-3xl mx-auto px-6 text-center">
          <p className="text-muted-foreground/60 text-xs italic" data-testid="pricing-indicative-note">{cta.priceNote}</p>
        </div>
        <section className="py-16 sm:py-24 bg-background" data-testid="pricing-cta">
          <div className="max-w-2xl mx-auto px-6 text-center">
            <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-foreground mb-3">{cta.title}</h2>
            <p className="text-muted-foreground text-sm sm:text-base mb-8">{cta.subtitle}</p>
            <WaitlistForm />
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}
